export default [
  {
    title: '',
    dataIndex: 'lessonNum',
    scopedSlots: { customRender: 'lock' },
    width: 30
  },
  {
    title: '讲次',
    dataIndex: 'lessonNum',
    scopedSlots: { customRender: 'lessonNum' },
    forbidHide: true,
    width: 100
  },
  {
    title: '讲次名称',
    dataIndex: 'lessonName',
    forbidHide: true,
    scopedSlots: { customRender: 'lessonName' }
  },
  // TODO 换字段
  {
    title: '本讲学习人数',
    dataIndex: 'studyUserCount',
    forbidHide: true,
    scopedSlots: { customRender: 'studyUserCount' }
  },
  // TODO 换字段
  {
    slots: { title: 'completeUserCountTitle' },
    dataIndex: 'completeUserCount',
    forbidHide: true,
    scopedSlots: { customRender: 'completeUserCount' }
  },
  {
    title: '待批改',
    dataIndex: 'correctionNum',
    scopedSlots: { customRender: 'correctionNum' }
  },
  {
    title: '被打回',
    dataIndex: 'repulseNum',
    forbidHide: true,
    scopedSlots: { customRender: 'repulseNum' }
  },
  {
    title: '五星',
    dataIndex: 'excellentNum',
    forbidHide: true,
    scopedSlots: { customRender: 'excellentNum' }
  },
  {
    dataIndex: 'correctionRate',
    forbidHide: true,
    slots: { title: 'correctionRateTitle' },
    scopedSlots: { customRender: 'correctionRate' }
  },
  {
    dataIndex: 'studentSubmitRate',
    forbidHide: true,
    slots: { title: 'submitRateTitle' },
    scopedSlots: { customRender: 'submitRate' }
  },
  {
    title: '操作',
    dataIndex: 'schemeName',
    forbidHide: true,
    scopedSlots: { customRender: 'action' },
    width: 150
  }
]